import { gfmFootnoteFromMarkdown, gfmFootnoteToMarkdown } from 'mdast-util-gfm-footnote';
import {
    gfmStrikethroughFromMarkdown,
    gfmStrikethroughToMarkdown,
} from 'mdast-util-gfm-strikethrough';
import { gfmTableFromMarkdown, gfmTableToMarkdown } from 'mdast-util-gfm-table';
import {
    gfmTaskListItemFromMarkdown,
    gfmTaskListItemToMarkdown,
} from 'mdast-util-gfm-task-list-item';
import { gfmFootnote } from 'micromark-extension-gfm-footnote';
import { gfmStrikethrough } from 'micromark-extension-gfm-strikethrough';
import { gfmTable } from 'micromark-extension-gfm-table';
import { gfmTaskListItem } from 'micromark-extension-gfm-task-list-item';
import { combineExtensions } from 'micromark-util-combine-extensions';
import type { Plugin } from 'unified';

/**
 * Custom variant of reamrk-gfm to disallow autolink.
 * We don't include autolnks because:
 * - https://github.com/syntax-tree/mdast-util-gfm-autolink-literal/issues/4
 * - if the user type a url in the editor, it could be generating a different content in markdown
 */
export const remarkGfm: Plugin<[] | []> = function remarkGfm() {
    const data = this.data();

    data.micromarkExtensions = data.micromarkExtensions ?? [];
    data.micromarkExtensions.push(
        combineExtensions([gfmStrikethrough(), gfmFootnote(), gfmTable(), gfmTaskListItem()])
    );

    data.fromMarkdownExtensions = data.fromMarkdownExtensions ?? [];
    data.fromMarkdownExtensions.push(
        ...[
            gfmStrikethroughFromMarkdown(),
            gfmTableFromMarkdown(),
            gfmTaskListItemFromMarkdown(),
            gfmFootnoteFromMarkdown(),
        ]
    );

    data.toMarkdownExtensions = data.toMarkdownExtensions ?? [];
    data.toMarkdownExtensions.push(
        ...[
            gfmStrikethroughToMarkdown(),
            gfmTableToMarkdown(),
            gfmFootnoteToMarkdown(),
            gfmTaskListItemToMarkdown(),
        ]
    );
};
